module.exports = __webpack_public_path__ + "img/a645148.webp";